import { useRecoilState } from "recoil";
import {
    Footer,
    FooterWrapper,
    FooterLinkSection,
    FooterLinkLabel,
    FooterLinkText,
    FooterInternalLink,
    FooterDivider,
    FooterCopyrightWrapper,
    FooterCopyrightText,
    FooterSocialMediaWrapper,
    FooterSocialMediaIcon,
    FooterSocialTermsLinkWrapper,
    FooterExternalLink,
    FooterDesktopMediaSection,
    FooterMobileMediaSection,
} from "./footerStyling";
import { useLocation } from "react-router-dom";
import { loggedInSelector } from "../../state/selectors/loggedIn";
import React from "react";

const FooterComponent: React.FC = () => {
    const location = useLocation();
    const [userLoggedIn] = useRecoilState(loggedInSelector);

    return (
        <Footer location={location.pathname}>
            <FooterWrapper location={location.pathname}>
                {/* <FooterHeaderWrapper className="hidden">
                </FooterHeaderWrapper> */}
                {/* <FooterDivider className="hidden" style={{ gridRow: "2/3", gridColumn: "1/5" }} /> */}
                <FooterLinkSection first={true} className="hidden">
                    <div style={{ 
                        marginTop: '48px',
                        marginBottom: '16px',
                        textAlign: 'left',
                        width: '100%'
                    }}>
                        <img 
                            src="https://d292awxalydr86.cloudfront.net/Branding/Anystay.svg" 
                            alt="Anystay Logo" 
                            style={{ 
                                height: '32px',
                                width: 'auto'
                            }} 
                        />
                    </div>
                    {/* <FooterLinkMainLabel>Get help for your journey</FooterLinkMainLabel> */}
                    {/* <FooterLinkA href="https://help.anystay.com/" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLink>Go to help center</FooterLink>
                    </FooterLinkA> */}
                    {/* <FooterLinkA href="https://help.anystay.com" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLink>What's new</FooterLink>
                    </FooterLinkA>
                    <FooterLinkA href="https://help.anystay.com" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLink>
                            Stay safety
                        </FooterLink>
                    </FooterLinkA>
                    <FooterLinkA href="https://help.anystay.com" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLink>
                            Feedback
                        </FooterLink>
                    </FooterLinkA>
                    <FooterLinkA href="https://help.anystay.com" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLink>
                            Careers
                        </FooterLink>
                    </FooterLinkA> */}
                    <FooterDesktopMediaSection>
                        <FooterSocialTermsLinkWrapper className="reverse">
                            {/* <FooterTermsWrapper>
                        <FooterTermsLink to="/terms-and-conditions">Terms</FooterTermsLink>
                        <FooterTermsLink to="/privacy-policy">Privacy</FooterTermsLink>
                    </FooterTermsWrapper> */}
                            <FooterSocialMediaWrapper>
                                <a target="_blank" rel="noreferrer" href="https://www.instagram.com/anystay.com.au/">
                                    <FooterSocialMediaIcon src={"https://d292awxalydr86.cloudfront.net/Footer/ig1.png"} alt={"instagram icon"} />
                                </a>
                                <a target="_blank" rel="noreferrer" href="https://www.facebook.com/anystay.com.au/">
                                    <FooterSocialMediaIcon src={"https://d292awxalydr86.cloudfront.net/Footer/fb1.png"} alt={"Facebook icon"} />
                                </a>
                                <a target="_blank" rel="noreferrer" href="https://www.tiktok.com/@anystay.com.au/">
                                    <FooterSocialMediaIcon src={"https://d292awxalydr86.cloudfront.net/Social-Icons/Tiktok.svg"} alt={"Tiktok icon"} />
                                </a>
                            </FooterSocialMediaWrapper>
                        </FooterSocialTermsLinkWrapper>
                        <FooterCopyrightWrapper>
                            <FooterCopyrightText>© 2025, Anystay Pty Ltd</FooterCopyrightText>
                        </FooterCopyrightWrapper>
                    </FooterDesktopMediaSection>
                    <FooterDivider />
                </FooterLinkSection>
                <FooterLinkSection className="hidden">
                    <FooterLinkLabel>Explore</FooterLinkLabel>
                    <FooterInternalLink
                        to={
                            'search/Australia/ChIJ38WHZwf9KysRUhNblaFnglM/anyArrival/anyDeparture/%7B"typeOfPlace":[],"propertyType":[],"priceRange":%7B"min":0,"max":1000%7D,"guests":1,"adults":1,"children":0,"infants":0,"pets":0,"bedrooms":1,"bathrooms":0,"amenities":[],"services":[],"houseRules":[]%7D'
                        }
                    >
                        <FooterLinkText>Find a place to stay</FooterLinkText>
                    </FooterInternalLink>
                    <FooterExternalLink href="https://help.anystay.com/en/collections/3862266-guests" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLinkText>How it works</FooterLinkText>
                    </FooterExternalLink>
                    <FooterExternalLink href="https://help.anystay.com/en/collections/3862266-guests" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLinkText>Help for guests</FooterLinkText>
                    </FooterExternalLink>
                    <FooterExternalLink href="https://help.anystay.com/en/articles/7007327-changes" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLinkText>Change request</FooterLinkText>
                    </FooterExternalLink>
                    <FooterExternalLink href="https://help.anystay.com/en/articles/7007448-refunds" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLinkText>Refund request</FooterLinkText>
                    </FooterExternalLink>
                    <FooterInternalLink to="/refer">
                        <FooterLinkText>Invite a friend</FooterLinkText>
                    </FooterInternalLink>

                    <FooterDivider />
                </FooterLinkSection>
                <FooterLinkSection className="hidden">
                    <FooterLinkLabel>Hosting</FooterLinkLabel>
                    <FooterInternalLink to={userLoggedIn ? `/listings/1` : "/list-your-place"}>
                        <FooterLinkText>List your place</FooterLinkText>
                    </FooterInternalLink>
                    <FooterInternalLink to={userLoggedIn ? `/listings/1` : "/list-your-place"}>
                        <FooterLinkText>List your room</FooterLinkText>
                    </FooterInternalLink>
                    <FooterExternalLink href="https://help.anystay.com/en/collections/3862361-hosts" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLinkText>Help for hosts</FooterLinkText>
                    </FooterExternalLink>
                    <FooterInternalLink to={`/listings/1`}>
                        <FooterLinkText>Manage listings</FooterLinkText>
                    </FooterInternalLink>
                    <FooterExternalLink href="https://help.anystay.com/en/articles/7016728-how-to-start-hosting" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLinkText>Getting started</FooterLinkText>
                    </FooterExternalLink>
                    <FooterInternalLink to="/invite">
                        <FooterLinkText>Refer a host</FooterLinkText>
                    </FooterInternalLink>
                    <FooterDivider />
                </FooterLinkSection>
                <FooterLinkSection className="hidden">
                    <FooterLinkLabel>Support</FooterLinkLabel>
                    <FooterExternalLink href="https://help.anystay.com/" target={window.innerWidth > 768 ? "_blank" : ""} rel="noopener norefferer">
                        <FooterLinkText>Help Center</FooterLinkText>
                    </FooterExternalLink>
                    <FooterExternalLink href="https://help.anystay.com/en/articles/7007340-cancellations">
                        <FooterLinkText>Cancellations</FooterLinkText>
                    </FooterExternalLink>
                    <FooterExternalLink href="https://help.anystay.com/en/articles/7007327-changes">
                        <FooterLinkText>Changes</FooterLinkText>
                    </FooterExternalLink>
                    <FooterExternalLink href="https://help.anystay.com/en/articles/7007403-deposits">
                        <FooterLinkText>Deposits</FooterLinkText>
                    </FooterExternalLink>
                    <FooterInternalLink to="/terms-and-conditions">
                        <FooterLinkText>Term of use</FooterLinkText>
                    </FooterInternalLink>
                    <FooterInternalLink to="/privacy-policy">
                        <FooterLinkText>Privacy policy</FooterLinkText>
                    </FooterInternalLink>
                    <FooterDivider />
                </FooterLinkSection>

                <FooterMobileMediaSection>
                    <FooterSocialTermsLinkWrapper className="reverse">
                        {/* <FooterTermsWrapper>
                        <FooterTermsLink to="/terms-and-conditions">Terms</FooterTermsLink>
                        <FooterTermsLink to="/privacy-policy">Privacy</FooterTermsLink>
                    </FooterTermsWrapper> */}
                        <FooterSocialMediaWrapper>
                            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/anystay.com.au/">
                                <FooterSocialMediaIcon src={"https://d292awxalydr86.cloudfront.net/Footer/ig1.png"} alt={"instagram icon"} />
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.facebook.com/anystay.com.au/">
                                <FooterSocialMediaIcon src={"https://d292awxalydr86.cloudfront.net/Footer/fb1.png"} alt={"Facebook icon"} />
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.tiktok.com/anystay.com.au/">
                                <FooterSocialMediaIcon src={"https://d292awxalydr86.cloudfront.net/Social-Icons/Tiktok.svg"} alt={"Tiktok icon"} />
                            </a>
                        </FooterSocialMediaWrapper>
                    </FooterSocialTermsLinkWrapper>
                    <FooterCopyrightWrapper>
                        <FooterCopyrightText>© 2025, Anystay Pty Ltd</FooterCopyrightText>
                    </FooterCopyrightWrapper>
                </FooterMobileMediaSection>
            </FooterWrapper>
        </Footer>
    );
};

export default FooterComponent;
